import { FoxpostEmptyList } from "./foxpost-empty-list";
import { FoxpostOpeningTimes } from "./foxpost-opening-times";
import { FoxpostSubstitute } from "./foxpost-substitue";

export class MessageFromFoxpost {
    place_id?: number; 
    operator_id?: string; 
    name?: string; 
    vapt?:string; 
    olapt?:string; 
    japt?:string; 
    ssapt?:string; 
    sdapt?:string; 
    group?:string;  
    address?:string; 
    allowed2?:string; 
    apmType?: string; 
    fillEmptyList?: FoxpostEmptyList[]; 
    isOutdoor?:boolean; 
    zip?:string; 
    city?:string; 
    street?:string; 
    substitutes?:FoxpostSubstitute[];
    load?:string; 
    findme?:string;  
    geolat?:number; 
    geolng?:number; 
    open?:FoxpostOpeningTimes; 



}